<template>
  <div class="page-header page-home">
    <div class="text">
      <div class="title">{{ agreementData.name }}</div>
      <div v-html="agreementData.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "unicomDeal6",
  data() {
    return {
      text: "",
      id: null,
      agreementData: {
        name: "",
        content: "",
      },
    };
  },
  watch: {
    "$route.query"() {
      this.id = this.$route.query.id;
      this.getProtocols();
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getProtocols();
  },
  methods: {
    // 获取协议信息
    async getProtocols() {
      let list = JSON.parse(localStorage.getItem("dealTextList"));
      list.map((v) => {
        if (v.id == this.id) {
          this.agreementData = v;
        }
      });
      console.log("agreementData ==>", this.agreementData);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-home {
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;

  .text {
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    white-space: pre-wrap;
    .title {
      font-weight: 800;
      text-align: center;
      margin: 1rem auto;
    }
  }
}
</style>
